import "./style.scss";

import React, {useEffect, useState} from "react";
import { useHistory } from 'react-router-dom';

import { IoReloadOutline } from 'react-icons/io5';

import { Text, Button } from '../';

import { getProfileInfo } from 'services/utils';
import { getLevelNodeEnrollment } from "services/api";

function EnrollmentProcessing({ processing, collection, updateProcessing = null }:any) {
    const history = useHistory();
    const [updateActive, setUpdateActive] = useState(true);

    const handleEnrollmentProcessing = (e: React.MouseEvent<HTMLElement>) => {
        setUpdateActive(false);

        const updateEnrollmentIdEnrollment = updateProcessing && updateProcessing?.idEnrollment;
        const idEnrollment =
            collection?.data?.enrollment?.idEnrollment ||
            collection.data?.nodeEnrollment?.enrollment?.idEnrollment ||
            updateEnrollmentIdEnrollment;

        const nodeCode = collection?.data?.nodeEnrollment?.node?.nodeCode || collection?.data?.nodeCode;

        getLevelNodeEnrollment(getProfileInfo().idUser, idEnrollment, nodeCode)
            .then(({ data }) => {
                const { node } = data;
                if (node?.nodeEnrollment?.enrollment) {
                    const processing = node?.nodeEnrollment?.enrollment?.processing;
                    if (processing === 0) {
                        const routerLinkTemp = `/level/${idEnrollment}`;
                        history.push(routerLinkTemp);
                    }

                    setUpdateActive(true);
                }
            })
            .catch((error) => {
                console.log(error);
            });

        e.stopPropagation();
    };

    return processing ? (
        <div className={`pctAtom enrollmentProcessing`}>
            <div className={`enrollmentProcessingBase`}>
                <Text component="p" text={`Sua matrícula está sendo processada...`} />
                <Text
                    component="small"
                    text={`Isso pode levar alguns minutos. Volte mais tarde ou clique em atualizar para verificar se o processo já foi concluído.`}
                />
                <Button
                    ico={IoReloadOutline}
                    text={'Atualizar'}
                    callEvent={handleEnrollmentProcessing}
                    className={`button03 ${!updateActive ? 'updateInactive' : ''}`}
                />
            </div>
        </div>
    ) : (
        <></>
    );
}

export default EnrollmentProcessing;
